import { flushSync } from "react-dom"

export const WILSON_BAR_TRANSITION =
    "wilson-bar-morph [view-transition-name:wilson-bar]"

type Morph = "grow" | "shrink"

const MORPH_CLASS: Record<Morph, string> = {
    grow: "wilson-bar-growing",
    shrink: "wilson-bar-shrinking",
}

function canMorph(): boolean {
    if (typeof document === "undefined") return false
    if (typeof document.startViewTransition !== "function") return false
    return !window.matchMedia?.("(prefers-reduced-motion: reduce)").matches
}

export function runViewTransition({
    update,
    morph,
}: {
    update: () => void
    morph: Morph
}) {
    if (!canMorph()) {
        update()
        return
    }
    const root = document.documentElement
    root.classList.add(MORPH_CLASS[morph])
    const transition = document.startViewTransition(() => flushSync(update))
    transition.ready.catch(() => {
        // A skipped morph still applies the update; there is just no animation.
    })
    void transition.finished.finally(() =>
        root.classList.remove(MORPH_CLASS[morph])
    )
}
